import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './index.css';

import '@packages/axios';
import '@packages/i18n';
import { bootstrapCsrf } from '@lib/bootstrapCsrf';

import { routes } from './routes';

const rootEl = document.getElementById('root')!;

// Render ASAP to avoid a blank screen while CSRF bootstrap runs.
createRoot(rootEl).render(
  <>
    <RouterProvider router={routes} />
    <ToastContainer />
  </>
);

// Fetch CSRF token in the background.
// If the request is slow/hangs, we stop waiting after a short timeout.
void (async () => {
  const timeoutMs = 1500;

  try {
    await Promise.race([
      bootstrapCsrf(),
      new Promise<void>((resolve) => setTimeout(resolve, timeoutMs)),
    ]);
  } catch {
    // bootstrapCsrf already logs a warning; don't crash startup
  }
})();
